/*
  element container quick add
 */
class QuickAddComponent extends HTMLElement {
  constructor() {
    super();

    this.toggleSizeGuideModal = this.toggleSizeGuideModal.bind(this);
    this.addToCart = this.addToCart.bind(this);
    this.hideError = this.hideError.bind(this);
    this.toggleForm = this.toggleForm.bind(this);
  }

  /**
   *
   *
   * @function
   */
  connectedCallback() {
    this.querySelector(".open-drop-js")?.addEventListener(
      "click",
      this.toggleForm
    );
    this.querySelector(".close-drop-js")?.addEventListener(
      "click",
      this.toggleForm
    );

    this.querySelector("[data-js-open-size-guide]")?.addEventListener(
      "click",
      this.toggleSizeGuideModal
    );

    this.querySelector("[data-js-close-size-guide]")?.addEventListener(
      "click",
      this.toggleSizeGuideModal
    );

    this.querySelector(".add-cart-js")?.addEventListener(
      "click",
      this.addToCart
    );
  }

  toggleSizeGuideModal(event) {
    const parent = event.currentTarget.closest("quick-add-component");
    const modal = parent.querySelector(".size-guide");

    if (modal.open) {
      modal?.close();
      return;
    }

    modal?.showModal();
  }

  hideError() {
    const errorMessage = this.querySelector(".error-cart-js");
    errorMessage.innerText = "";
    errorMessage.setAttribute("hidden", "");
  }

  toggleForm(event) {
    this.hideError();
    const containerParent = event.target.closest("quick-add-component");
    if (containerParent.classList.contains("active-quick")) {
      containerParent.classList.remove("active-quick");
      return;
    }
    containerParent.classList.add("active-quick");
  }

  showError(message) {
    const errorMessage = this.querySelector(".error-cart-js");
    errorMessage.innerText = message;
    errorMessage.removeAttribute("hidden");
    errorMessage.focus();
  }

  addToCartFirstCallback(requestState) {
    const button = this.querySelector(".add-cart-js");

    button.innerText = window.variantStrings.addToCart;
    button.removeAttribute("aria-busy");

    if (requestState.responseData.status !== 200) {
      console.error(requestState.responseData.status);
      if (
        requestState.responseData.status === 422 &&
        requestState.responseData.body.message
      ) {
        this.showError(requestState.responseData.body.message);
      }
    }
  }

  addToCart(event) {
    const parent = event.currentTarget.closest(".card-quick-add__component");
    const variantContainer = parent.querySelector("quick-add-cart.active-size");
    const variantId = variantContainer?.dataset.variant;
    const button = this.querySelector(".add-cart-js");

    if (!variantId) {
      this.showError(window.variantStrings.chooseASize);
      return;
    }

    // Update button to say Adding...
    button.innerText = window.variantStrings.addingToCart;
    button.setAttribute("aria-busy", true);

    const body = {
      items: [
        {
          id: Number(variantId),
          quantity: 1,
        },
      ],
    };

    const options = {
      firstCallback: (requestState) =>
        this.addToCartFirstCallback(requestState),
      important: true,
    };

    liquidAjaxCart.add(body, options);

    return;
  }
}
customElements.define("quick-add-component", QuickAddComponent);

/*
  element onclick add to cart
*/
class QuickAddToCart extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListener("click", this.updateSelected);
  }

  updateSelected(event) {
    const containerParent = event.currentTarget.closest("quick-add-component");
    const allSize = containerParent.querySelectorAll(".options-add-js");

    allSize.forEach((sizeButtom) => {
      sizeButtom.classList.remove("active-size");
    });
    event.currentTarget.classList.add("active-size");

    const parent = event.currentTarget.closest(".card-quick-add__component");
    this.hideError(parent);
  }

  hideError(parent) {
    const errorMessage = parent.querySelector(".error-cart-js");
    errorMessage.innerText = "";
    errorMessage.setAttribute("hidden", "");
  }
}

customElements.define("quick-add-cart", QuickAddToCart);
